import { Table } from 'reactstrap';
import { ISearchOrgResult } from '../../../types/org';
import { useState } from 'react';
import PaginationBar from '../../common/pagination-bar';
import OmsToolTip from '../../common/oms-tooltip/oms-tooltip';
import { Pageable } from '../../../types/common';
import TableHeaders, { TableHeaderInfo } from '../../common/table-header';
import { phoneNumberAutoFormat2 } from '../../../utils/format-phone';
import Button from '../../common/button';
import { FaRegCircleXmark } from 'react-icons/fa6';

const PAGE_SIZE = 10;

interface SearchOrgResultProp extends Pageable<ISearchOrgResult> {
  selected: any | undefined;
  onOrgSelect: (item: ISearchOrgResult) => void;
  inputChanged: boolean;
  isInputError: boolean;
}

const TABLE_HEADERS: TableHeaderInfo<ISearchOrgResult>[] = [
  { header: "Name", accessor: "orgName", sortable: true, hidden: false },
  { header: "Address", accessor: "addressUsages", sortable: true, hidden: false },
  { header: "Phone/Fax", accessor: "contactPhones", sortable: true, hidden: false, cssClass: "phone-column" },
];

function SearchOrgResult(props: SearchOrgResultProp) {
  const { data: orgs, selected, onOrgSelect, inputChanged, isInputError } = props;
  const [sortedData, setSortedData] = useState<ISearchOrgResult[]>([]);
  const [pagedData, setPagedData] = useState<ISearchOrgResult[]>([]);
  // FIXME: remove the <div> tags from the table cells
  return (
    <>
      <Table id="orgs_table" striped className="fixed">
        <caption className="sr-only">Search results, sortable</caption>
        <TableHeaders headers={TABLE_HEADERS} sortableData={orgs} onSort={setSortedData} />

        <tbody>
          {sortedData.length>0
            ? pagedData.map((org:ISearchOrgResult, index) => {
              return <tr key={org.id+'-'+index}>
                <td>
                  <Button color='link'
                    className={`oms-button-link ${selected === searchOrgSelectedOrg(org) ? 'oms-button-link-selected' : '' }`}
                    id={`${org.id}-${index}-title`}
                    onClick={()=>{onOrgSelect(org)}}>
                      <OmsToolTip orgId={org.id}>
                          {org.orgName}
                      </OmsToolTip>
                  </Button>
                  
                </td>
                <td>
                  {org.addressUsages && org.addressUsages.map((addr, i) => (
                    <div key={addr.addressId+'-'+i}>{addr.addressTxt+' '+addr.addressTxt2}{ addr.addressExpired && <span> <FaRegCircleXmark/></span>}</div>
                  ))}
                </td>
                <td>
                  {org.contactPhones && org.contactPhones.map((phone,i) => (
                    <div key={phone.id+"-"+i}>{phoneNumberAutoFormat2("",phone.areaCode,phone.localNumber,phone.extension)}</div>
                  ))}
                </td>
              </tr>;
              })
            :<tr><td colSpan={TABLE_HEADERS.length} className="text-center">
              {inputChanged? (isInputError ? 'No results found.' : 'Search results will appear in the table.') :'No organization names were found with the exact search match.'}</td></tr>
          }
        </tbody>
      </Table>

      <PaginationBar data={sortedData} pageSize={PAGE_SIZE} onPageChange={setPagedData} />
    </>
  )
}

export function searchOrgSelectedOrg(record: ISearchOrgResult) : string {
  return `search-org-selected-org-${record.id}`;
}

export default SearchOrgResult
